import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ChatFormBuilder } from './chat-form.builder';
import { FormGroup } from '@angular/forms';
import { IFormFieldErrorMessages } from '../form/form-master.interface';
import { FormService } from '../../services/form/form.service';
import { IChatFormSubmit } from './chat-form.data';

@Component({
  selector: 'i2g-chat-form',
  templateUrl: 'chat-form.component.html',
  styleUrls: ['chat-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ChatFormBuilder],
})
export class ChatFormComponent implements OnInit {
  /**
   * Label for message field
   */
  @Input() messageLabel: string;

  /**
   * Placeholder for message field
   */
  @Input() messagePlaceholder: string;

  /**
   * error messages for message field
   */
  @Input() messageErrorMessages: IFormFieldErrorMessages;

  /**
   * submit button label
   */
  @Input() buttonLabel: string;

  /**
   * submit processing label
   */
  @Input() processingLabel;

  /**
   * submit is in progress
   */
  @Input() isSubmitProcessing = false;

  /**
   * form submitted event
   */
  @Output() submitForm = new EventEmitter<IChatFormSubmit>();

  form: FormGroup;
  formKeys: any;
  messageMaxLength = 4000;

  constructor(
    private _builder: ChatFormBuilder,
    private _formService: FormService
  ) {}

  ngOnInit() {
    this.formKeys = this._builder.FORM_KEYS;
    this.form = this._builder.buildForm(this.messageMaxLength);
  }

  onSubmitForm() {
    this._formService.markControlsInFormGroupDirty(this.form);

    if (this.form.valid) {
      this.submitForm.emit(this.form.value);
      this.form.reset();
    }
  }
}
